import { defineStore } from 'pinia';
import type {
    IQuizAnswersSummaryResponse,
    IQuizDetailsQuestionsResponse,
    IQuizDetailsResponse
} from '@/models/QuizModel';

interface IQuizStore {
    quizInfo: IQuizDetailsResponse | null
    userAnswers: IQuizDetailsQuestionsResponse[] | null
    quizSubmitResponse: IQuizAnswersSummaryResponse | null
}

export const useQuizStore = defineStore('useQuizStore', {
    state: (): IQuizStore => ({
        quizInfo: null,
        userAnswers: null,
        quizSubmitResponse: null,
    }),
    actions: {
        setQuizInfo (quizInfoValue: IQuizDetailsResponse | null) {
            this.quizInfo = quizInfoValue;
        },
        setUserAnswers (userAnswersValue: IQuizDetailsQuestionsResponse[] | null) {
            this.userAnswers = userAnswersValue;
        },
        setQuizSubmitResponse (quizSubmitResponseValue: IQuizAnswersSummaryResponse | null) {
            this.quizSubmitResponse = quizSubmitResponseValue;
        },
    },
});
